import { defineStore, acceptHMRUpdate } from 'pinia'
import { ref } from 'vue'

export const useMypageProposalStore = defineStore('mypageProposalStore', () => {

    const proposalList= ref([]);
    const proposalUserList= ref([]);
    const selectedProposalDetail = ref({
        propId: null,
        title: '',
    });

    const setProposalList = (list) => {
        proposalList.value = list;
    }

    const setProposalUserList = (list) => {
        proposalUserList.value = list;
    }

    const setSelectedProposalDetail = (detail) => {
        selectedProposalDetail.value = {
            propId: detail?.propId ?? detail?.id ?? null,
            title: detail?.title ?? '',
        };
    }

    const clearSelectedProposalDetail = () => {
        selectedProposalDetail.value = {
            propId: null,
            title: '',
        };
    }

    return {
        proposalList,
        setProposalList,
        proposalUserList,
        setProposalUserList,
        selectedProposalDetail,
        setSelectedProposalDetail,
        clearSelectedProposalDetail,
    }
})

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useMypageProposalStore, import.meta.hot))
}